





















































































































import {Component, Prop} from "vue-property-decorator";
import WarehouseTable from "@/modules/warehouses/shared/components/WarehouseTable/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {PickingListDeliveryStore} from "@/modules/pickinglistdeliveries";
import {Lading} from "@/interfaces/entity";
import {PickingListDeliveryType} from "@/enums/type";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";

@Component({
  name: "PLDeliveryExcel",
  components: {LadingStatusLabel, WarehouseTable}
})
export default class extends mixins(CommonMixin) {
  @Prop({required: true, type: Number}) readonly id!: number;
  PickingListDeliveryType = PickingListDeliveryType;

  get billLadings() {
    const billLadings = this.getProp(this.pickingListDelivery, 'billLadings', []) as any;
    return billLadings.map((billLading: Lading, index) => ({...billLading, stt: index + 1}));
  }

  get pickingListDelivery() {
    return PickingListDeliveryStore.data[this.id];
  }

  get receiverCollect() {
    const receiverCollect = this.getProp(this.pickingListDelivery, 'receiverCollect');
    return receiverCollect
        ? receiverCollect.toLocaleString('en-US') + 'đ'
        : 0;
  }
}
